module.exports = __webpack_public_path__ + "static/media/protokol_active.5e2d2a9a.jpg";